export const CREATE_PARKING_SPACE_NAME = 'CREATE_PARKING_SPACE_NAME';
export const EDIT_PARKING_SPACE_NAME = 'EDIT_PARKING_SPACE_NAME';
export const SHOW_PARKING_SPACE_NAME = 'SHOW_PARKING_SPACE_NAME';
export const PARKING_SPACE_NAME_SUCCESS = 'PARKING_SPACE_NAME_SUCCESS';
export const PARKING_SPACE_NAME_ERROR = 'PARKING_SPACE_NAME_ERROR';